<template>
  <div v-loading="loading" element-loading-text="Loading" style="height: 800px"></div>
</template>

<script>
import { getCookie, setCookie } from "../../static/js/util.js";
export default {
  name: "selectApplyPage",
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    var switchUrl = getCookie("select_page_user_has_enter");
    console.log("cookies", switchUrl);
    if (switchUrl == undefined) {
      this.$axios
        .get(this.$URL.selectApplyUrl)
        .then((res) => {
          this.loading = false;
          console.log(res.msg);
          if (res && res.code == 0) {
            var url = res.data;
            if (url) {
              setCookie("select_page_user_has_enter", url);
              // window.location.href = url;
            }
            // this.$message.success({ message: res.msg });
            //} else {
            // this.$message.error({ message: res.msg });
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          // this.$message.error({ message: err });
        });
    }
    //else {
    //var decodeUrl = decodeURIComponent(switchUrl);
    //window.location.href = decodeUrl;
    //}

    this.$router.push("/apply");

    // var now = new Date()
    // var min = now.getMinutes()
    // console.log('当前分钟',min)
    // var maxMin = this.$Constans.maxMin
    // console.log(min/maxMin);
    // if(!this.$Constans.toNewApplyPage&&min/maxMin<1){
    //     window.location.href = this.$Constans.applyUrl
    //     console.log('当前时间的分钟<40,应该跳转到旧的apply地址/login')
    // }else{
    //     console.log('当前时间的分钟>40或者设置为跳转到新页面,应该跳转到旧的apply地址/login')
    //     this.$router.push('/login')
    // }
    // setTimeout(()=>{
    //     this.loading=false
    // },500)
  },
};
</script>

<style scoped>
</style>